<template>
    <b-modal id="supplier_delete" ref="supplier_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="setTitle">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('supplier_delete')" v-text="'Cancel'"/>

            <state-button size="sm" v-if="mode === 'supplier'" variant="danger" :click="deleteSupplier">Delete
            </state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "SupplierDeleteModal",

    components: {
        StateButton,
    },

    computed: {
        setTitle() {
            if (this.mode === 'supplier') {
                return 'Delete ' + this.supplier.data.attributes.name + '?';
            } else {
                return 'Delete supplier?';
            }
        },
    },

    props: [
        'mode'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteSupplier() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteSupplier', this.supplier)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-supplier');

                            this.$notify('error filled', 'Success!', 'Deleted the supplier!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('supplier_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
